import { api } from './client';
import { PathOpenerItem } from '../types/entities/path-opener-item.entity';
import {
    PathOpenerCatalogResponse,
    PathOpenerEntryResponse,
} from '../types/responses/path-opener.responses';

export type PathOpenerItemPayload = {
    value: string;
    name?: string | null;
    description?: string | null;
    mode?: string;
    position?: number;
    priority?: number;
};

export const pathOpenerItemService = {
    getCatalog: async (options?: { limit?: number }): Promise<PathOpenerItem[]> => {
        const limit = options?.limit;
        const suffix =
            limit != null && limit > 0
                ? `?limit=${encodeURIComponent(String(limit))}`
                : '';
        const response = await api.get<PathOpenerCatalogResponse>(
            `/path-opener-items/catalog${suffix}`,
        );
        return response.data.data.entries;
    },

    create: async (payload: PathOpenerItemPayload): Promise<PathOpenerItem> => {
        const response = await api.post<PathOpenerEntryResponse>('/path-opener-items', payload);
        return response.data.data.entry;
    },

    update: async (id: string, payload: PathOpenerItemPayload): Promise<PathOpenerItem> => {
        const response = await api.put<PathOpenerEntryResponse>(
            `/path-opener-items/${encodeURIComponent(id)}`,
            payload
        );
        return response.data.data.entry;
    },

    delete: async (id: string): Promise<void> => {
        await api.delete(`/path-opener-items/${encodeURIComponent(id)}`);
    },
};
